"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var moment = require("moment");
var CardRowDateEdit = /** @class */ (function (_super) {
    __extends(CardRowDateEdit, _super);
    function CardRowDateEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.GRID_CARD_CSS = { width: '100%', textAlign: 'center', boxShadow: "none", padding: "10px" };
        return _this;
    }
    CardRowDateEdit.prototype.onValueChange = function (date, dateString) {
        // console.log(`date str->${dateString}`);
        // console.log(`date year->${parseInt(date.format('YYYY'))}; month->${parseInt(date.format('MM'))}; day->${parseInt(date.format('DD'))}`);
        if (this.props.onValueChanged) {
            this.props.onValueChanged(parseInt(date.format('YYYY')), parseInt(date.format('MM')), parseInt(date.format('DD')));
        }
    };
    CardRowDateEdit.prototype.getValue = function () {
        var _ret = moment(this.props.value.month + "-" + this.props.value.day + "-" + this.props.value.year, 'MM-DD-YYYY');
        return _ret;
    };
    CardRowDateEdit.prototype.render = function () {
        return (React.createElement(antd_1.Card.Grid, { style: this.GRID_CARD_CSS },
            React.createElement("div", { style: { display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" } },
                React.createElement(antd_1.Input.Group, { compact: true },
                    React.createElement("div", { style: {
                            width: "224px",
                            height: "32px",
                            color: "rgba(0,0,0,.65)",
                            textAlign: "center",
                            borderTopLeftRadius: "4px",
                            borderBottomLeftRadius: "4px",
                            backgroundColor: "#fafafa",
                            borderWidth: "1px",
                            borderStyle: "solid",
                            borderColor: "#d9d9d9",
                            fontSize: "14px",
                            fontWeight: 400,
                            lineHeight: "31px",
                            borderRightWidth: "0px",
                            borderRightColor: "#d9d9d9",
                        } }, this.props.texts.caption),
                    React.createElement(antd_1.DatePicker, { style: {
                            width: "calc( 100% - 224px )",
                            borderBottomLeftRadius: 0,
                            borderTopLeftRadius: 0,
                            borderLeftWidth: 0,
                            borderLeftColor: "#d9d9d9",
                            textAlign: "start"
                        }, placeholder: this.props.texts.placeholder, onChange: this.onValueChange.bind(this), value: this.getValue(), disabled: this.props.disabled, allowClear: false })))));
    };
    return CardRowDateEdit;
}(React.Component));
exports.default = CardRowDateEdit;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/editors/CardRowDateEdit.tsx
// module id = 91
// module chunks = 0